import React, { useCallback, useEffect, useState } from "react"
import { Form, Button, Table } from "react-bootstrap"
import { Link } from "react-router-dom"
import * as api from "../../lib/api"
import { ILicense, ISortType } from "../../lib/interface"
import { BsFillCaretDownFill } from "@react-icons/all-files/bs/BsFillCaretDownFill"
import { BsFillCaretUpFill } from "@react-icons/all-files/bs/BsFillCaretUpFill"

function App() {
  const [licenses, setLicenses] = useState<ILicense[]>([])
  const [searchText, setSearchText] = useState("")
  const [attempting] = useState(false)
  const [sortType, setSortType] = useState<ISortType>(null)

  useEffect(() => {
    getLicenses()
  }, [sortType])

  const getLicenses = async () => {
    const json = await api.getLicensesDb(searchText, sortType?.type, sortType?.order)
    console.log(json)
    setLicenses(json?.data)
  }

  const handleNameChange = useCallback((e: any) => setSearchText(e.target.value), [])

  const handleSortTypeChange = (e: { currentTarget: { id: string } }) => {
    //typeが切り替わるタイミングで"asc"にする
    if (sortType?.order === "desc") {
      setSortType({ type: e.currentTarget.id, order: "asc" })
    } else {
      setSortType({ type: e.currentTarget.id, order: "desc" })
    }
  }

  return (
    <>
      <h1 className="h4">ライセンス一覧</h1>
      <div className="mb-3">
        <Link to={`/license/create/`} className="btn-primary btn-sm btn">
          新規作成
        </Link>
      </div>
      <Form className="search-area mb-5">
        <div className="row">
          <div className="col-9 py-4">
            <Form.Group>
              <Form.Control placeholder="名前" type="text" disabled={attempting} onChange={handleNameChange} />
            </Form.Group>
          </div>
          <div className="col-2 d-flex align-items-center">
            <Button disabled={attempting} onClick={() => getLicenses()} className="search-btn btn-block">
              検索
            </Button>
          </div>
        </div>
      </Form>
      許可カテゴリやユーザ数など表示するか
      <div className="table-scroll">
        <Table hover className="admin-table">
          <thead className="bg-light text-center">
            <tr>
              <th></th>
              <th>
                <Link to="#" onClick={handleSortTypeChange} className="link" id="view_number">
                  {sortType?.type === "view_number" && <div>active</div>}
                  {sortType?.type === "view_number" && sortType?.order === "desc" ? (
                    <BsFillCaretUpFill />
                  ) : (
                    <BsFillCaretDownFill />
                  )}
                </Link>
                表示順
              </th>
              <th>名前</th>
              <th>
                <Link to="#" onClick={handleSortTypeChange} className="link" id="update_date">
                  {sortType?.type === "update_date" && <div>active</div>}
                  {sortType?.type === "update_date" && sortType?.order === "desc" ? (
                    <BsFillCaretUpFill />
                  ) : (
                    <BsFillCaretDownFill />
                  )}
                </Link>
                更新日
              </th>
              <th>
                <Link to="#" onClick={handleSortTypeChange} className="link" id="status">
                  {sortType?.type === "status" && <div>active</div>}
                  {sortType?.type === "status" && sortType?.order === "desc" ? (
                    <BsFillCaretUpFill />
                  ) : (
                    <BsFillCaretDownFill />
                  )}
                </Link>
                ステータス
              </th>
            </tr>
          </thead>
          <tbody className="text-center">
            {licenses?.length > 0 &&
              licenses?.map((license: ILicense, index: number) => {
                return (
                  <tr key={license.id}>
                    <td>{index + 1}</td>
                    <td>{license.viewNumber}</td>
                    <td>
                      <Link to={`/license/${license.id}/`} className="">
                        {license.name}
                      </Link>
                    </td>
                    <td>{license.updateDate}</td>
                    <td>
                      {license.status ? <div className="text-info">有効</div> : <div className="text-danger">無効</div>}
                    </td>
                  </tr>
                )
              })}
          </tbody>
        </Table>
      </div>
    </>
  )
}

export default App
